export default "__VITE_ASSET__CwKo6tv2__"